const { admin } = require("data/authData");

export const allowAccess = (role, user, department) => {
	if (user.role[role]) return true;
	if (user.role[admin]) return true;
	if (user.role[department]) return true;

	return false;
};
